import { GoodsTransfersOrdersService } from "./../../../services/documents/GoodsTransfersOrdersService";
import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CreateGoodsTransfersOrdersDto } from "../../../dtos/documents/GoodsTransfersOrders/CreateGoodsTransfersOrdersDto";
import { NFLookupGoodsTransfersOrders } from "../../../components/Shared/NewForms/NFLookupGoodsTransfersOrders";
import {
  GoodsTransfersOrdersDetail
} from "../../../components/Pages/Documents/Warehouse/GoodsTransferOrders/GoodsTransfersOrdersDetail";
import GoodsTransfersOrdersList
  from "../../../components/Pages/Documents/Warehouse/GoodsTransferOrders/GoodsTransfersOrdersList";

export const GoodsTransfersOrders: IAppEntity = {
  entityType: "document",
  title: "Goods Transfers Orders",
  pluralTitle: "Goods Transfers Orders",
  apiUrl: "GoodsTransferOrders",
  apiEnum: ReferenceTypes.DocumentPostingOfGood,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(GoodsTransfersOrdersDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(GoodsTransfersOrdersList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupGoodsTransfersOrders, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new GoodsTransfersOrdersService("GoodsTransferOrders"),
  getEmptyModel: () => {
    const model: CreateGoodsTransfersOrdersDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      goodsTransferOrderGoods: [],
      createdDate: new Date(),
      desiredShippingDate: new Date(),
      comment: "",
    };
    return model;
  },
};
